import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withApollo } from "react-apollo";
import { push } from 'connected-react-router';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

import ModelForm from './components/ModelForm';

import { parseFormErrors } from '../shared/utils/form_errors';
import { CreateSneakerModelMutation } from './queries';

class NewModel extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    const { client, push } = this.props;
    data.orderPriority = 0;
    return client.mutate({ mutation: CreateSneakerModelMutation, variables: { record: data } })
      .then(() => push('/model'))
      .catch(parseFormErrors);
  }

  render() {
    return (
      <div id="new-model">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/model">Model</Link></Breadcrumb.Item>
          <Breadcrumb.Item>New Item</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <ModelForm onSubmit={this.handleSubmit} />
        </div>
      </div>
    );
  }
}

export default compose(
  connect(null, { push }),
  withApollo,
)(NewModel);
